const CudaLaunchCommon = require("CudaLaunchCommon");
const NavigationManager = require("common/NavigationManager");
const RootController = require("common/RootController");
const ConnectionPlugin = require("connect/ConnectionPlugin");
const TOTPLogonPlugin = require("./TOTPLogonPlugin");
const FeatureTable = require("common/FeatureTable");
const postal = require("common/PubSub");
const Utils = require("common/Utils");
const TOTPFullScreenView = require("./TOTPFullScreenView");
const TOTPHeader = require("./TOTPHeader");

var mobileInitFired = false;

var startup = function() {
    if (!mobileInitFired) {
        setTimeout(startup, 50);
    } else {
        CudaLaunch.clientConfiguration.isTouch = function() {
            return false;
        };

        CudaLaunchCommon("TOTP");

        const featureTable = new FeatureTable();
        featureTable.setMinSupportedServerVersion("8.0.1");
        $.extend(window.App, {
            getFeatureTable : function() {
                return featureTable;
            }
        });

        document.addEventListener("deviceready", function() {
            $(document).trigger("frameworkready");
        }, false);
    }
};

module.exports = function() {
    $(document).one("mobileinit", function() {
        // Stop jQuery Mobile from auto initializing. We will manually do this after any extra bits of the app have been configured
        $.mobile.autoInitializePage = false;

        mobileInitFired = true;
    });

    $(document).on("appinit", function() {
        document.title = Utils.getServerProductName();

        const navManager = CudaLaunch.navManager = new NavigationManager();
        const rootController = new RootController(navManager, CudaLaunch.clientConfiguration);
        CudaLaunch.controllers["RootController"] = rootController;

        const totpHeader = new TOTPHeader();
        rootController.addContentView("totp", new TOTPFullScreenView(totpHeader));

        // Need to add options menu entries to the totpHeader as well as to the mainHeader
        // Should probably register the totpHeader with RootController and allow that to add menu entries
        postal.channel("RootController").subscribe("add-options-menu-entry", function(data) {
            totpHeader.addOptionsMenuEntry(data.title, data.handler, data.weight);
        });

        new ConnectionPlugin().start();
        new TOTPLogonPlugin(CudaLaunch.clientConfiguration).start();
        postal.publish({
            channel : "RootController",
            topic : "rootControllerLoaded",
            data : {controller : rootController}
        });
    });

    $.ajaxSetup({
        // Globally handle any 401 responses
        statusCode : {
            401 : function() {
                var session = CudaLaunch.serverConfiguration.getSession();

                if (session) {
                    console.info("401 returned from server");
                    CudaLaunch.controllers.RootController.showErrorDialog($.t("common::auth.expired.title"), false, undefined, function() {
                        $.event.trigger("userunauthenticated");
                        CudaLaunch.serverConfiguration.clearSession();
                    });
                }
            }
        }
    });

    startup();
};